module.exports = __webpack_public_path__ + "static/media/mh.8fb2e631.svg";